import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-4" }
const _hoisted_2 = {
  class: "w-full pb-4 flex flex-col rounded-xl bg-lp-white border border-gray-lp-1300",
  style: {"box-shadow":"0px 1px 4px 0px rgba(26, 20, 33, 0.15)"}
}
const _hoisted_3 = {
  class: "relative w-full rounded-xl border border-pink-lp-300 flex flex-col py-4 px-6 overflow-hidden",
  style: {"background":"linear-gradient(95deg, #FFF9F7 0%, #F7C9D2 100%)"}
}
const _hoisted_4 = { class: "flex flex-row items-center" }
const _hoisted_5 = { class: "flex flex-row items-center justify-between w-1/2" }
const _hoisted_6 = { class: "text-red-lp-100 font-semibold font-montserrat text-base xxl:text-lg" }
const _hoisted_7 = { class: "text-xl xxl:text-24px text-red-lp-100 font-bold font-montserrat" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { style: {"width":"1px","height":"29px","background":"var(--Interpack3, #DC8F92)","margin-left":"32px","margin-right":"32px"} }, null, -1)
const _hoisted_9 = { class: "flex flex-row items-center justify-between w-1/2" }
const _hoisted_10 = { class: "text-red-lp-100 font-semibold font-montserrat text-base xxl:text-lg" }
const _hoisted_11 = { class: "text-xl xxl:text-24px text-red-lp-100 font-bold font-montserrat" }
const _hoisted_12 = { class: "text-sm xxl:text-16px font-semibold" }
const _hoisted_13 = { class: "grid grid-cols-4 mt-4 px-4" }
const _hoisted_14 = { class: "flex flex-col border-r gap-x-1 border-gray-lp-1400 text-sm xxl:text-16px font-normal text-gray-lp-800 pr-4" }
const _hoisted_15 = { class: "flex flex-row items-center gap-x-1 text-sm xxl:text-16px font-normal text-gray-lp-800" }
const _hoisted_16 = /*#__PURE__*/_createVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createVNode("path", {
    d: "M20 10V6C20 4.89543 19.1046 4 18 4H6C4.89543 4 4 4.89543 4 6V18C4 19.1046 4.89543 20 6 20H10",
    stroke: "#78787A",
    "stroke-width": "2",
    "stroke-linecap": "round"
  }),
  /*#__PURE__*/_createVNode("path", {
    d: "M10 4V3H9V4H10ZM14 4H15V3H14V4ZM14 8V9C14.5523 9 15 0.55228 15 8H14ZM10 8H9C9 8.55228 9.44772 9 10 9V8ZM10 5H14V3H10V5ZM13 4V8H15V4H13ZM14 7H10V9H14V7ZM11 8V4H9V8H11Z",
    fill: "#78787A"
  }),
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M11.9911 14.0546C11.9909 14.0546 11.9915 14.0528 11.9933 14.0494C11.9922 14.0528 11.9912 14.0546 11.9911 14.0546ZM12.08 13.9481C12.0587 13.9682 12.0423 13.9855 12.0296 14C12.0423 14.0145 12.0587 14.0318 12.08 14.0519C12.2106 14.1754 12.4532 14.3327 12.8359 14.4857C13.5957 14.7897 14.7139 15 16 15C17.2861 15 18.4043 14.7897 19.1641 14.4857C19.5468 14.3327 19.7894 14.1754 19.92 14.0519C19.9413 14.0318 19.9577 14.0144 19.9704 14C19.9577 13.9855 19.9413 13.9682 19.92 13.9481C19.7894 13.8246 19.5468 13.6673 19.1641 13.5143C18.4043 13.2103 17.2861 13 16 13C14.7139 13 13.5957 13.2103 12.8359 13.5143C12.4532 13.6673 12.2106 13.8246 12.08 13.9481ZM22 14C22 13.3603 21.6718 12.852 21.2942 12.495C20.9187 12.1399 20.4291 11.8662 19.9069 11.6573C18.8571 11.2374 17.4754 11 16 11C14.5246 11 13.1429 11.2374 12.0931 11.6573C11.5709 11.8662 11.0813 12.1399 10.7058 12.495C10.3282 12.852 10 13.3603 10 14V17C10 17.6397 10.3282 18.148 10.7058 18.505C11.0813 18.8601 11.5709 19.1338 12.0931 19.3427C13.1429 19.7626 14.5246 20 16 20C17.4754 20 18.8571 19.7626 19.9069 19.3427C20.4291 19.1338 20.9187 18.8601 21.2942 18.505C21.6718 18.148 22 17.6397 22 17V14ZM20 16.3046C19.9691 16.3175 19.9381 16.3302 19.9069 16.3427C18.8571 16.7626 17.4754 17 16 17C14.5246 17 13.1429 16.7626 12.0931 16.3427C12.0619 16.3302 12.0309 16.3175 12 16.3046V16.9618C12.0111 16.9787 12.0344 17.0088 12.08 17.0519C12.2106 17.1754 12.4532 17.3327 12.8359 17.4857C13.5957 17.7897 14.7139 18 16 18C17.2861 18 18.4043 17.7897 19.1641 17.4857C19.5468 17.3327 19.7894 17.1754 19.92 17.0519C19.9656 17.0088 19.9889 16.9787 20 16.9618V16.3046ZM20.0089 14.0546C20.0088 14.0546 20.0078 14.0528 20.0067 14.0493C20.0085 14.0528 20.0091 14.0546 20.0089 14.0546ZM20.0067 13.9506C20.0078 13.9472 20.0088 13.9454 20.0089 13.9454C20.0091 13.9454 20.0085 13.9472 20.0067 13.9506ZM11.9933 13.9506C11.9915 13.9472 11.9909 13.9454 11.9911 13.9454C11.9912 13.9454 11.9922 13.9472 11.9933 13.9506ZM20.0087 16.9464C20.0089 16.9458 20.009 16.9454 20.0089 16.9454C20.0088 16.9454 20.0078 16.9472 20.0067 16.9506C20.0077 16.9486 20.0084 16.9472 20.0087 16.9464ZM11.9911 16.9454C11.9912 16.9454 11.9922 16.9472 11.9933 16.9507C11.9915 16.9472 11.9909 16.9454 11.9911 16.9454Z",
    fill: "#78787A"
  })
], -1)
const _hoisted_17 = { class: "text-lg xxl:text-20px font-bold text-gray-lp-300 my-2" }
const _hoisted_18 = { class: "grid grid-cols-2 gap-x-2" }
const _hoisted_19 = { class: "flex flex-col font-normal" }
const _hoisted_20 = { class: "text-10px xxl:text-sm text-gray-lp-800" }
const _hoisted_21 = { class: "text-10px xxl:text-sm text-red-lp-100 font-bold mt-1" }
const _hoisted_22 = { class: "flex flex-col font-normal" }
const _hoisted_23 = { class: "text-10px xxl:text-sm text-gray-lp-800" }
const _hoisted_24 = { class: "text-10px xxl:text-sm text-gray-lp-300 font-bold mt-1" }
const _hoisted_25 = { class: "flex flex-col border-r gap-x-1 border-gray-lp-1400 text-sm xxl:text-16px font-normal text-gray-lp-800 px-4" }
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "flex flex-row items-center gap-x-1 text-sm xxl:text-16px font-normal text-gray-lp-800" }, [
  /*#__PURE__*/_createVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M5 4C4.4 4 4 4.4 4 5V11C4 11.6 3.6 12 3 12C2.4 12 2 11.6 2 11V5C2 3.3 3.3 2 5 2H19C20.7 2 22 3.3 22 5V11C22 11.6 21.6 12 21 12C20.4 12 20 11.6 20 11V5C20 4.4 19.6 4 19 4H15V7C15 7.6 14.6 8 14 8H10C9.4 8 9 7.6 9 7V4H5ZM13 6H11V4H13V6Z",
      fill: "#78787A"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M3 20C3 20.6 3.4 21 4 21H6C7.7 21 9 19.7 9 18V16C9 14.3 7.7 13 6 13H4C3.4 13 3 13.4 3 14V20ZM6 19H5V15H6C6.6 15 7 15.4 7 16V18C7 18.6 6.6 19 6 19Z",
      fill: "#78787A"
    }),
    /*#__PURE__*/_createVNode("path", {
      d: "M14 21H11C10.4 21 10 20.6 10 20V14C10 13.4 10.4 13 11 13H14C14.6 13 15 13.4 15 14C15 14.6 14.6 15 14 15H12V16H14C14.6 16 15 16.4 15 17C15 17.6 14.6 18 14 18H12V19H14C14.6 19 15 19.4 15 20C15 20.6 14.6 21 14 21Z",
      fill: "#78787A"
    }),
    /*#__PURE__*/_createVNode("path", {
      d: "M19.1 20.4C19.3 20.8 19.6 21 20 21C20.2 21 20.3 21 20.5 20.9C20.9 20.7 21.1 20.1 20.9 19.6L19.6 17L20.9 14.3C21 14.2 21 14.1 21 13.9C21 13.5 20.8 13.2 20.4 13C19.9 12.7 19.3 12.9 19.1 13.4L18.5 14.6L17.9 13.4C17.7 13 17.1 12.8 16.6 13C16.2 13.2 16 13.8 16.2 14.3L17.5 16.9L16.2 19.5C15.9 20 16.1 20.6 16.6 20.8C17.1 21.1 17.7 20.9 17.9 20.4L18.5 19.2L19.1 20.4Z",
      fill: "#78787A"
    })
  ]),
  /*#__PURE__*/_createTextVNode(" DEX ")
], -1)
const _hoisted_27 = { class: "text-lg xxl:text-20px font-bold text-gray-lp-300 my-2" }
const _hoisted_28 = { class: "text-10px xxl:text-sm font-semibold" }
const _hoisted_29 = { class: "grid grid-cols-2 gap-x-2" }
const _hoisted_30 = { class: "flex flex-col font-normal" }
const _hoisted_31 = { class: "text-10px xxl:text-sm text-gray-lp-800" }
const _hoisted_32 = { class: "text-10px xxl:text-sm text-red-lp-100 font-bold mt-1" }
const _hoisted_33 = { class: "font-normal text-12px" }
const _hoisted_34 = { class: "flex flex-col font-normal" }
const _hoisted_35 = { class: "text-10px xxl:text-sm text-gray-lp-800" }
const _hoisted_36 = { class: "text-10px xxl:text-sm text-gray-lp-300 font-bold mt-1" }
const _hoisted_37 = { class: "font-normal text-12px" }
const _hoisted_38 = { class: "flex flex-col border-r gap-x-1 border-gray-lp-1400 text-sm xxl:text-16px font-normal text-gray-lp-800 px-4" }
const _hoisted_39 = /*#__PURE__*/_createVNode("div", { class: "flex flex-row items-center gap-x-1 text-sm xxl:text-16px font-normal text-gray-lp-800" }, [
  /*#__PURE__*/_createVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createVNode("path", {
      d: "M20 12V6C20 4.89543 19.1046 4 18 4H6C4.89543 4 4 4.89543 4 6V18C4 19.1046 4.89543 20 6 20H11",
      stroke: "#78787A",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }),
    /*#__PURE__*/_createVNode("path", {
      d: "M10 4V3H9V4H10ZM14 4H15V3H14V4ZM14 8V9C14.5523 9 15 8.55228 15 8H14ZM10 8H9C9 8.55228 9.44772 9 10 9V8ZM10 5H14V3H10V5ZM13 4V8H15V4H13ZM14 7H10V9H14V7ZM11 8V4H9V8H11Z",
      fill: "#78787A"
    }),
    /*#__PURE__*/_createVNode("path", {
      d: "M16.7071 13.7071C17.0976 13.3166 17.0976 12.6834 16.7071 12.2929C16.3166 11.9024 15.6834 11.9024 15.2929 12.2929L13.2929 14.2929C13.1054 14.4804 13 14.7348 13 15C13 15.2652 13.1054 15.5196 13.2929 15.7071L15.2929 17.7071C15.6834 18.0976 16.3166 18.0976 16.7071 17.7071C17.0976 17.3166 17.0976 16.6834 16.7071 16.2929L16.4142 16H17.5C18.3284 16 19 16.6716 19 17.5C19 18.3284 18.3284 19 17.5 19H14C13.4477 19 13 19.4477 13 20C13 20.5523 13.4477 21 14 21H17.5C19.433 21 21 19.433 21 17.5C21 15.567 19.433 14 17.5 14H16.4142L16.7071 13.7071Z",
      fill: "#78787A"
    })
  ]),
  /*#__PURE__*/_createTextVNode(" CODREJ ")
], -1)
const _hoisted_40 = { class: "text-lg xxl:text-20px font-bold text-gray-lp-300 my-2" }
const _hoisted_41 = { class: "text-10px xxl:text-sm font-semibold" }
const _hoisted_42 = { class: "grid grid-cols-2 gap-x-2" }
const _hoisted_43 = { class: "flex flex-col font-normal" }
const _hoisted_44 = { class: "text-10px xxl:text-sm text-gray-lp-800" }
const _hoisted_45 = { class: "text-10px xxl:text-sm text-red-lp-100 font-bold mt-1" }
const _hoisted_46 = { class: "font-normal text-12px" }
const _hoisted_47 = { class: "flex flex-col font-normal" }
const _hoisted_48 = { class: "text-10px xxl:text-sm text-gray-lp-800" }
const _hoisted_49 = { class: "text-10px xxl:text-sm text-gray-lp-300 font-bold mt-1" }
const _hoisted_50 = { class: "font-normal text-12px" }
const _hoisted_51 = { class: "flex flex-col gap-x-1 text-sm xxl:text-16px font-normal text-gray-lp-800 pl-4" }
const _hoisted_52 = { class: "flex flex-row items-center gap-x-1 text-sm xxl:text-16px font-normal text-gray-lp-800" }
const _hoisted_53 = /*#__PURE__*/_createVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M5 4C4.4 4 4 4.4 4 5V19C4 19.6 4.4 20 5 20H6C6.6 20 7 20.4 7 21C7 21.6 6.6 22 6 22H5C3.3 22 2 20.7 2 19V5C2 3.3 3.3 2 5 2H19C20.7 2 22 3.3 22 5V9C22 9.6 21.6 10 21 10C20.4 10 20 9.6 20 9V5C20 4.4 19.6 4 19 4H15V7C15 7.55229 14.5523 8 14 8H10C9.44772 8 9 7.55229 9 7V4H5ZM11 6H13V4H11V6Z",
    fill: "#78787A"
  }),
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M6.3999 10.3999C5.84762 10.3999 5.3999 10.8476 5.3999 11.3999C5.3999 11.9522 5.84762 12.3999 6.3999 12.3999H14.5001V18.5999H13.5001C13.4001 18.3999 13.2001 18.0999 13.0001 17.8999C12.6001 17.4999 12.0001 17.1999 11.3001 17.1999C10.6001 17.1999 10.2001 17.4999 9.7001 17.9999L9.6001 18.0999V16.2999H7.6001V19.0999C7.6001 19.5999 7.8001 19.9999 8.1001 20.2999C8.4001 20.5999 8.8001 20.7999 9.2001 20.7999C9.3001 20.9999 9.5001 21.2999 9.7001 21.4999C10.1001 21.8999 10.7001 22.1999 11.4001 22.1999C12.1001 22.1999 12.6001 21.9999 13.1001 21.4999C13.3001 21.2999 13.5001 21.0999 13.6001 20.7999H14.9001C15.1001 20.7999 15.4001 20.7999 15.6001 20.6999C15.8001 20.7999 16.0001 20.7999 16.2001 20.7999C16.3001 20.9999 16.5001 21.2999 16.7001 21.4999C17.1001 21.8999 17.7001 22.1999 18.4001 22.1999C19.0001 22.1999 19.6001 21.8999 20.1001 21.4999C20.3001 21.2999 20.5001 21.0999 20.6001 20.7999C21.0001 20.7999 21.4001 20.5999 21.7001 20.2999C22.0001 19.9999 22.2001 19.5999 22.2001 19.0999V15.9999C22.0001 15.3999 21.8001 14.8999 21.5001 14.5999L19.2001 12.2999C18.9001 11.9999 18.4001 11.7999 18.0001 11.7999H16.5001C16.4001 11.4999 16.3001 11.1999 16.0001 10.8999C15.7001 10.5999 15.3001 10.3999 14.8001 10.3999H6.3999ZM11.4001 19.9999C11.5001 19.9999 11.6001 19.9999 11.7001 19.8999C11.7001 19.8499 11.7251 19.7999 11.7501 19.7499C11.7751 19.6999 11.8001 19.6499 11.8001 19.5999C11.8001 19.4999 11.8001 19.3999 11.7001 19.2999C11.6001 19.1999 11.5001 19.1999 11.4001 19.1999C11.3001 19.1999 11.2001 19.1999 11.1001 19.2999C11.0001 19.3999 11.0001 19.4999 11.0001 19.5999C11.0001 19.6999 11.0001 19.7999 11.1001 19.8999C11.2001 19.9999 11.3001 19.9999 11.4001 19.9999ZM18.3001 19.9999C18.4001 19.9999 18.5001 19.9999 18.5001 19.8999C18.6001 19.7999 18.7001 19.6999 18.7001 19.5999C18.7001 19.4999 18.7001 19.3999 18.6001 19.2999C18.5001 19.1999 18.4001 19.1999 18.3001 19.1999C18.2001 19.1999 18.1001 19.1999 18.0001 19.2999C17.9001 19.3999 17.9001 19.4999 17.9001 19.5999C17.9001 19.6999 17.9001 19.7999 18.0001 19.8999C18.1001 19.9999 18.2001 19.9999 18.3001 19.9999ZM19.9001 17.9038C19.9338 17.935 19.9672 17.967 20.0001 17.9999H19.9001V17.9038ZM19.9001 15.8999V17.9038C19.4211 17.4617 18.8606 17.1999 18.3001 17.1999C17.7001 17.1999 17.1001 17.3999 16.6001 17.8999L16.5001 17.9999V13.7999H17.8001L19.9001 15.8999Z",
    fill: "#78787A"
  }),
  /*#__PURE__*/_createVNode("path", {
    d: "M7.29981 13.3C6.74752 13.3 6.29981 13.7478 6.29981 14.3001C6.29981 14.8523 6.74752 15.3001 7.29981 15.3001H10.0998C10.6521 15.3001 11.0998 14.8523 11.0998 14.3001C11.0998 13.7478 10.6521 13.3 10.0998 13.3H7.29981Z",
    fill: "#78787A"
  })
], -1)
const _hoisted_54 = { class: "text-lg xxl:text-20px font-bold text-gray-lp-300 my-2" }
const _hoisted_55 = { class: "text-10px xxl:text-sm font-semibold" }
const _hoisted_56 = { class: "grid grid-cols-2 gap-x-2" }
const _hoisted_57 = { class: "flex flex-col font-normal" }
const _hoisted_58 = /*#__PURE__*/_createVNode("p", { class: "text-10px xxl:text-sm text-gray-lp-800" }, "DEL", -1)
const _hoisted_59 = { class: "text-10px xxl:text-sm text-red-lp-100 font-bold mt-1" }
const _hoisted_60 = { class: "font-normal text-10px xxl:text-sm" }
const _hoisted_61 = { class: "flex flex-col font-normal" }
const _hoisted_62 = /*#__PURE__*/_createVNode("p", { class: "text-10px xxl:text-sm text-gray-lp-800" }, " POD/CODREJ/DEX ", -1)
const _hoisted_63 = { class: "text-10px xxl:text-sm text-gray-lp-300 font-bold mt-1.5" }
const _hoisted_64 = { class: "font-normal text-10px xxl:text-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("codReconcile.detail.totalMoneyToDeposit")), 1),
            _createVNode("p", _hoisted_7, _toDisplayString(_ctx.formatPrice(_ctx.data.codAmountDeposit.pending)), 1)
          ]),
          _hoisted_8,
          _createVNode("div", _hoisted_9, [
            _createVNode("p", _hoisted_10, _toDisplayString(_ctx.$t("codReconcile.detail.totalSttToDeposit")), 1),
            _createVNode("p", _hoisted_11, [
              _createTextVNode(_toDisplayString(_ctx.sttDeposit.pending) + " STT ", 1),
              _createVNode("span", _hoisted_12, "(" + _toDisplayString(_ctx.sttDeposit.pendingPieces) + " " + _toDisplayString(this.$t("codReconcile.dailyDeposit.koli")) + ")", 1)
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_13, [
        _createVNode("div", _hoisted_14, [
          _createVNode("div", _hoisted_15, [
            _hoisted_16,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("codReconcile.summary.totalCodMoney")), 1)
          ]),
          _createVNode("p", _hoisted_17, _toDisplayString(_ctx.formatPrice(
                _ctx.data.codAmountDeposit.pending + _ctx.data.codAmountDeposit.collected
              )), 1),
          _createVNode("div", _hoisted_18, [
            _createVNode("div", _hoisted_19, [
              _createVNode("p", _hoisted_20, _toDisplayString(_ctx.$t("codReconcile.summary.mustDeposit")), 1),
              _createVNode("p", _hoisted_21, _toDisplayString(_ctx.formatPrice(_ctx.data.codAmountDeposit.pending)), 1)
            ]),
            _createVNode("div", _hoisted_22, [
              _createVNode("p", _hoisted_23, _toDisplayString(_ctx.$t("codReconcile.summary.alreadyDeposit")), 1),
              _createVNode("p", _hoisted_24, _toDisplayString(_ctx.formatPrice(_ctx.data.codAmountDeposit.collected)), 1)
            ])
          ])
        ]),
        _createVNode("div", _hoisted_25, [
          _hoisted_26,
          _createVNode("p", _hoisted_27, [
            _createTextVNode(_toDisplayString(_ctx.sttDepositDex.collected + _ctx.sttDepositDex.pending) + " STT ", 1),
            _createVNode("span", _hoisted_28, "(" + _toDisplayString(_ctx.sttDepositDex.collectedPieces + _ctx.sttDepositDex.pendingPieces) + " " + _toDisplayString(this.$t("codReconcile.dailyDeposit.koli")) + ")", 1)
          ]),
          _createVNode("div", _hoisted_29, [
            _createVNode("div", _hoisted_30, [
              _createVNode("p", _hoisted_31, _toDisplayString(_ctx.$t("codReconcile.summary.mustDeposit")), 1),
              _createVNode("p", _hoisted_32, [
                _createTextVNode(_toDisplayString(_ctx.sttDepositDex.pending) + " STT ", 1),
                _createVNode("span", _hoisted_33, "(" + _toDisplayString(_ctx.sttDepositDex.pendingPieces) + " " + _toDisplayString(_ctx.$t("codReconcile.dailyDeposit.koli")) + ")", 1)
              ])
            ]),
            _createVNode("div", _hoisted_34, [
              _createVNode("p", _hoisted_35, _toDisplayString(_ctx.$t("codReconcile.summary.alreadyDeposit")), 1),
              _createVNode("p", _hoisted_36, [
                _createTextVNode(_toDisplayString(_ctx.sttDepositDex.collected) + " STT ", 1),
                _createVNode("span", _hoisted_37, "(" + _toDisplayString(_ctx.sttDepositDex.collectedPieces) + " " + _toDisplayString(_ctx.$t("codReconcile.dailyDeposit.koli")) + ")", 1)
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_38, [
          _hoisted_39,
          _createVNode("p", _hoisted_40, [
            _createTextVNode(_toDisplayString(_ctx.sttDepositCodRej.collected + _ctx.sttDepositCodRej.pending) + " STT ", 1),
            _createVNode("span", _hoisted_41, "(" + _toDisplayString(_ctx.sttDepositCodRej.collectedPieces +
                  _ctx.sttDepositCodRej.pendingPieces) + " " + _toDisplayString(this.$t("codReconcile.dailyDeposit.koli")) + ")", 1)
          ]),
          _createVNode("div", _hoisted_42, [
            _createVNode("div", _hoisted_43, [
              _createVNode("p", _hoisted_44, _toDisplayString(_ctx.$t("codReconcile.summary.mustDeposit")), 1),
              _createVNode("p", _hoisted_45, [
                _createTextVNode(_toDisplayString(_ctx.sttDepositCodRej.pending) + " STT ", 1),
                _createVNode("span", _hoisted_46, "(" + _toDisplayString(_ctx.sttDepositCodRej.pendingPieces) + " " + _toDisplayString(_ctx.$t("codReconcile.dailyDeposit.koli")) + ")", 1)
              ])
            ]),
            _createVNode("div", _hoisted_47, [
              _createVNode("p", _hoisted_48, _toDisplayString(_ctx.$t("codReconcile.summary.alreadyDeposit")), 1),
              _createVNode("p", _hoisted_49, [
                _createTextVNode(_toDisplayString(_ctx.sttDepositCodRej.collected) + " STT ", 1),
                _createVNode("span", _hoisted_50, "(" + _toDisplayString(_ctx.sttDepositCodRej.collectedPieces) + " " + _toDisplayString(_ctx.$t("codReconcile.dailyDeposit.koli")) + ")", 1)
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_51, [
          _createVNode("div", _hoisted_52, [
            _hoisted_53,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("codReconcile.summary.inDelivery")), 1)
          ]),
          _createVNode("p", _hoisted_54, [
            _createTextVNode(_toDisplayString(_ctx.sttInDelivery.count) + " STT ", 1),
            _createVNode("span", _hoisted_55, "(" + _toDisplayString(_ctx.sttInDelivery.pieces) + " " + _toDisplayString(_ctx.$t("codReconcile.dailyDeposit.koli")) + ")", 1)
          ]),
          _createVNode("div", _hoisted_56, [
            _createVNode("div", _hoisted_57, [
              _hoisted_58,
              _createVNode("p", _hoisted_59, [
                _createTextVNode(_toDisplayString(_ctx.sttInDeliveryDel.count) + " STT ", 1),
                _createVNode("span", _hoisted_60, "(" + _toDisplayString(_ctx.sttInDeliveryDel.pieces) + " " + _toDisplayString(_ctx.$t("codReconcile.dailyDeposit.koli")) + ")", 1)
              ])
            ]),
            _createVNode("div", _hoisted_61, [
              _hoisted_62,
              _createVNode("p", _hoisted_63, [
                _createTextVNode(_toDisplayString(_ctx.sttInDeliveryProcess.count) + " STT ", 1),
                _createVNode("span", _hoisted_64, "(" + _toDisplayString(_ctx.sttInDeliveryProcess.pieces) + " " + _toDisplayString(_ctx.$t("codReconcile.dailyDeposit.koli")) + ")", 1)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}